<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[{ name: 'EDM Report', to: { path: '/edm-report' } }]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>EDM Report</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="exportHandler">
        <!--  -->
        <v-icon class="pr-2">get_app</v-icon>
        <span>匯出</span>
      </button>
    </div>
    <!--  -->
    <EDMReportTable class="mb-5"></EDMReportTable>
  </div>
</template>

<script>
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import EDMReportTable from '@/views/K__eNewsletterEDMreport/c/EDMReportTable.vue';

export default {
  components: {
    BreadScrumbs,
    EDMReportTable,
  },
  methods: {
    exportHandler() {
      console.log('export');
    },
  },
};
</script>

<style></style>
